import { useEffect, useState } from "react";
import { Ban, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function NonSvoltaDialog({ activity, onClose, onDone }) {
  const [motivo, setMotivo] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => setMotivo(""), [activity]);
  const save = async () => {
    setBusy(true);
    try { await api.post(`/activities/${activity.id}/non-svolta`, { motivo }); toast.success("Segnata come non svolta"); onDone?.(); onClose(); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
    setBusy(false);
  };
  return (
    <Dialog open={!!activity} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="nonsvolta-dialog" aria-describedby={undefined}>
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Ban className="h-5 w-5 text-amber-500" />Attività non svolta</DialogTitle></DialogHeader>
        <Textarea value={motivo} onChange={(e) => setMotivo(e.target.value)} rows={3} placeholder="Motivo (es. cliente assente, rinviato su richiesta…)" data-testid="nonsvolta-motivo" />
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annulla</Button>
          <Button onClick={save} disabled={busy || !motivo.trim()} data-testid="nonsvolta-confirm">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Conferma</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
